import { Component, ElementRef, ViewChild } from '@angular/core';
import { EcomanagerService } from '../ecomanager/Ecomanager.service';

@Component({
  templateUrl: './Ecopricing.component.html',
  styleUrls: ['./Ecopricing.component.css']
})
export class EcopricingComponent {

  hasCredentials = false;
  isLoading = true;
  subscription: any;
  private iframeLoaded = false;
  private formUpdated = false;
  formSubmited = false;

  @ViewChild('form', { static: true }) form: ElementRef;
  @ViewChild('formLoginUsuario', { static: true }) formLoginUsuario: ElementRef;
  @ViewChild('formLoginPassword', { static: true }) formLoginPassword: ElementRef;

  constructor(private ecomanagerService: EcomanagerService) {

    if ( this.ecomanagerService.isLoaded() ) {
      this.isLoading = false;
      this.checkCredentials();
    } else {
      this.subscription = this.ecomanagerService.loadedChange$.subscribe( loaded => {
        this.isLoading = !loaded;
        if ( loaded ) {
          this.checkCredentials();
        }
      });
    }


  }

  checkCredentials(){
    this.hasCredentials = this.ecomanagerService.getCredentialByServiceAndParam('ecopricing', 'username') != null
      && this.ecomanagerService.getCredentialByServiceAndParam('ecopricing', 'password') != null;
    if( this.hasCredentials ) {
      this.isLoading = true;
      this.formUpdated = true;
      this.waitForData();
    }
  }

  waitForData(){
    setTimeout(()=>{
      if ( this.formUpdated && this.iframeLoaded ) {
        setTimeout(()=>{
          this.formLoginUsuario.nativeElement.value = this.ecomanagerService.getCredentialByServiceAndParam('ecopricing', 'username');
          this.formLoginPassword.nativeElement.value = this.ecomanagerService.getCredentialByServiceAndParam('ecopricing', 'password');
          this.form.nativeElement.submit();
          this.formSubmited = true;
        }, 100);
      } else {
        this.waitForData();
      }
    }, 200);
  }

  public onIframeLoaded() {
    if (!this.iframeLoaded) {
      this.iframeLoaded = true;
    }
    if ( this.formSubmited ) {
      this.isLoading = false;
    }
  }

  public ngOnDestroy(): void {
    this.iframeLoaded = false;
    this.isLoading = true;
  }
}
